import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton } from '@mui/material';
import { useState } from 'react';

import { HeaderBlock } from '@styles/ContactManager/HeaderStyles';
import { colorTheme } from '@styles/muiTheme';

import { CommentsTabs } from './CommentsTabs/CommentsTabs';

export interface IContactManagerSidebarProps {
  contactId: string;
  title: string;
  children?: JSX.Element;
}

export const ContactManagerSidebar = ({ title, children }: IContactManagerSidebarProps) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Box sx={{ display: 'block'}}>
      <HeaderBlock>
        <IconButton size="small" color="inherit" onClick={() => setCollapsed(!collapsed)}>
          {!collapsed ? <ExpandLess /> : <ExpandMore />}
        </IconButton>

        {title}
      </HeaderBlock>

      <Collapse in={!collapsed}>
        <Box sx={{ background: `${colorTheme.palette.common.white}`, padding: '10px' }}>{children}</Box>
      </Collapse>

      <CommentsTabs />
    </Box>
  );
};
